import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';
import { PLATFORM_FEATURES } from '@/lib/constants/features';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute('/(client)/risk')({
  // Hiding the nav entry is not access control — these pages are reachable by
  // URL, so the guard lives here; `sidebarNavHelpers` only stops advertising
  // them. Both halves have to pass: the feature says the company bought Risk
  // Analysis, the permission says this user may use it.
  beforeLoad: async ({ location }) => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, PLATFORM_FEATURES.RISK_ANALYSIS_V3)) {
      throw redirect({ to: '/dashboard' });
    }

    // The same cache entry `usePermissions` reads, so the guard and the screens
    // beneath it cannot disagree and this costs no second request.
    const { risk } = await ensurePermissions();
    if (!risk.canRead) throw redirect({ to: '/dashboard' });

    // The bare section path has no index page — the `(list)` layout renders an
    // empty Outlet — so send it to the default tab like every other section.
    // Reachable from the "Risk" breadcrumb (BI-1804).
    if (location.pathname === '/risk' || location.pathname === '/risk/') {
      throw redirect({ to: '/risk/assessments' });
    }
  },
  component: () => <Outlet />,
});
